import React, { useState, useEffect } from "react";
import apiClient from '../utils/apiClient';
import Select from "react-select";
import Swal from 'sweetalert2';
import { SERVER_BASE } from '../config/server';
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEquals } from "@fortawesome/free-solid-svg-icons";

const MMSMappingForm = () => {
    const [isEdit, setIsEdit] = useState(false);
    const [editItemId, setEditItemId] = useState(null);
    const [itemGroup, setItemGroup] = useState(null);
    const [type, setType] = useState(null);
    const [itemGroupCode, setItemGroupCode] = useState("");
    const [itemCode, setItemCode] = useState("");
    const [itemName, setItemName] = useState("");
    const [printName, setPrintName] = useState("");
    const [itemDesc, setItemDesc] = useState("");
    const [size, setSize] = useState("");
    const [make, setMake] = useState("");
    const [color, setColor] = useState("");
    const [avgWeight, setAvgWeight] = useState("");
    const [uom, setUom] = useState(null);
    const [secondaryUom, setSecondaryUom] = useState(null);
    const [secondaryUnit, setSecondaryUnit] = useState(null);
    const [primaryQuantity, setPrimaryQuantity] = useState(null);
    const [secondaryQuantity, setSecondaryQuantity] = useState(null);
    const [brandName, setBrandName] = useState(null);
    const [unit, setUnit] = useState("");
    const [concernedDepartments, setConcernedDepartments] = useState([]);
    const [remarks, setRemarks] = useState("");
    const [additionalNames, setAdditionalNames] = useState([""]);
    const [grade, setGrade] = useState("");
    const [mmsCode, setMmsCode] = useState("");
    const [mmsName, setMmsName] = useState("");
    const [mmsDesc, setMmsDesc] = useState("");
    const [hsn, setHsn] = useState("");
    const [itemGroups, setItemGroups] = useState([]);
    const [departments, setDepartments] = useState([]);
    const code = localStorage.getItem("code");
    const email = localStorage.getItem("email");
    const token = localStorage.getItem("token");
    const role = localStorage.getItem('role');
    const [formVisible, setFormVisible] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [uoms, setUoms] = useState([]); // UOM data
    const navigate = useNavigate();
    const location = useLocation();
    const item = location?.state?.item;
    useEffect(() => {
        if (item) {
            handleEdit(item);
        }
    }, [item]);
    // Fetch Inventory Groups
    const fetchItemGroups = async () => {
        try {
            const response = await apiClient.get(SERVER_BASE + "/item-groups", {
                params: { code },
                headers: {
                    Authorization: `Bearer ${token}`, // Add the JWT token in the header
                },
            });
            setItemGroups(
                response.data.map((group) => ({
                    value: group.groupName,
                    label: `${group.groupCode} - ${group.groupName}`,
                    type: group.type,
                    itemGroupCode: group.groupCode,
                }))
            );
        } catch (error) {
            console.error("Error fetching item groups:", error);
        }
    };
    const fetchUOMs = async () => {
        try {
            const response = await apiClient.get(SERVER_BASE + "/getUoms", {
                params: { code },
                headers: {
                    Authorization: `Bearer ${token}`, // Add the JWT token in the header
                },
            });
            setUoms(
                response.data.map((uom) => ({
                    value: uom.abbreviation,
                    label: `${uom.unit} - ${uom.abbreviation}`,
                    unit: uom.unit
                }))
            );
        } catch (error) {
            console.error("Error fetching item groups:", error);
        }
    };

    // Fetch Departments
    const fetchDepartments = async () => {
        try {
            const response = await apiClient.get(SERVER_BASE + "/departments", {
                params: { code },

                headers: {
                    Authorization: `Bearer ${token}`, // Add the JWT token in the header
                },

            });
            const departmentsData = response.data;
            setDepartments(
                departmentsData.map((dept) => ({
                    value: dept.name,
                    label: dept.name,
                }))
            );
        } catch (error) {
            console.error("Error fetching departments:", error);
        }
    };
    const toggleFormVisibility = () => {
        navigate(-1)
    };

    // Function to update the Print Name dynamically
    useEffect(() => {
        const baseName = `${itemName} ${size} ${color}`.trim();
        const additionalDetails = [make, grade].filter(Boolean).join(" ");
        const newPrintName = additionalDetails
            ? `${baseName} - ${additionalDetails}`
            : baseName;
        setPrintName(newPrintName);
    }, [itemName, color, size, make, grade]); // Dependencies

    const handleChange = (setter) => (event) => {
        setter(event.target.value);
    };

    const handleSelectChange = (selectedOption, { name }) => {
        if (name === "itemGroup") {
            setItemGroup(selectedOption)
            setItemGroupCode(selectedOption?.itemGroupCode || "")
        }
        if (name === "uom") {
            setUom(selectedOption)
            setUnit(selectedOption?.unit || "")
        }
        if (name === "secondaryUom") {
            setSecondaryUom(selectedOption)
            setSecondaryUnit(selectedOption?.unit || "")
        }
        if (name === "type") {
            setType(selectedOption)
        }
    };

    const handleConcernedDeptSelectChange = (selectedOptions) => {
        if (selectedOptions.some((option) => option.value === "all")) {
            setConcernedDepartments(departments);
        } else {
            setConcernedDepartments(selectedOptions);
        }
    };
    const getOptions = () => {
        return [{ value: "all", label: "Select All" }, ...departments];
    };

    const handleAdditionalNameChange = (index, value) => {
        const newAdditionalNames = [...additionalNames];
        newAdditionalNames[index] = value;
        setAdditionalNames(newAdditionalNames);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Check if all required fields are filled
        if (!mmsName) {
            Swal.fire({
                icon: 'warning',
                text: 'Pleaser Enter MMS Name!',
                position: 'top-end',  // Positioning Swal to the right end
                showConfirmButton: false,
                timer: 1500, // Auto close after 1.5 seconds
                toast: true,
            });
            return;
        }
        if (!mmsCode) {
            Swal.fire({
                icon: 'warning',
                text: 'Pleaser Select MMS Code!',
                position: 'top-end',  // Positioning Swal to the right end
                showConfirmButton: false,
                timer: 1500, // Auto close after 1.5 seconds
                toast: true,
            });
            return;
        }
        if (!hsn) {
            Swal.fire({
                icon: 'warning',
                text: 'Pleaser Select HSN!',
                position: 'top-end',  // Positioning Swal to the right end
                showConfirmButton: false,
                timer: 1500, // Auto close after 1.5 seconds
                toast: true,
            });
            return;
        }
        if (uom && secondaryUom && uom === secondaryUom) {
            Swal.fire({
                icon: 'warning',
                text: 'Primary UOM and Secondary UOM cannot be the same!',
                position: 'top-end',
                showConfirmButton: false,
                timer: 1500,
                toast: true,
            });
            return;
        }

        // Validation: If secondary UOM is present, both primary and secondary quantity must be provided
        if (secondaryUom && (primaryQuantity == null || primaryQuantity === '' || secondaryQuantity == null || secondaryQuantity === '')) {
            Swal.fire({
                icon: 'warning',
                text: 'Both Primary Quantity and Secondary Quantity are required when Secondary UOM is provided!',
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000,
                toast: true,
            });
            return;
        }

        let submissionData = {
            mmsCode,
            mmsName,
            mmsDesc,
            hsn,
            secondaryUnit,
            secondaryUom,
            primaryQuantity,
            secondaryQuantity,
            email
        };

        try {
            await apiClient.post(`${SERVER_BASE}/updateMMS/${editItemId}`, submissionData, {
                headers: {
                    Authorization: `Bearer ${token}`, // Add the JWT token in the header
                }
            });
            Swal.fire({
                icon: 'success',
                title: 'MMS updated successfully!',
                toast: true,
                position: 'top-end',
                timer: 2000,
                showConfirmButton: false,
            });
            navigate(-1)
        } catch (error) {
            console.error("Error saving data:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response.data.message,
                position: 'top-end',  // Positioning Swal to the right end
                showConfirmButton: false,
                timer: 1500, // Auto close after 1.5 seconds
            });
        }
    };
    const handleUnMap = async () => {
        const confirmation = await Swal.fire({
          title: 'Are you sure?',
          text: 'Do you want to unmap this Inventory? This action cannot be undone!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, Unmap it!',
          cancelButtonText: 'Cancel',
        });
      
        if (confirmation.isConfirmed) {
          try {
            // Send the entire row data to the server
            await apiClient.put(`${SERVER_BASE}/unMapInventory/${editItemId}`, {
              data: {email},
              headers: {
                Authorization: `Bearer ${token}`, // Add the JWT token in the header
              },
            });
    
            Swal.fire({
              icon: 'success',
              title: 'Inventory Unmapped successfully!',
              toast: true,
              position: 'top-end',
              timer: 3000,
              showConfirmButton: false,
            });
            navigate(-1)
          } catch (error) {
            console.error('Error unmappig Inventory:', error);
      
            Swal.fire({
              icon: 'error',
              title: 'An error occurred while unmapping the Inventory.',
              toast: true,
              position: 'top-end',
              timer: 3000,
              showConfirmButton: false,
            });
          }
        }
      };
    useEffect(() => {
        fetchItemGroups();
        fetchDepartments();
        fetchUOMs();
    }, []);
    const handleEdit = (item) => {
        setFormVisible(true);
        setShowForm(false)
        setIsEdit(true);
        setEditItemId(item.id);
        setItemName(item.itemName)
        setAvgWeight(item.avgWeight)
        setColor(item.color)
        setSize(item.size)
        setMake(item.make)
        setGrade(item.grade)
        setBrandName(item.brandName)
        setPrintName(item.printName)
        setRemarks(item.remarks)
        setItemDesc(item.itemDesc)
        setItemCode(item.itemCode)
        // Ensure department and prefix are arrays
        const departmentArray = Array.isArray(item.concernedDepartments)
            ? item.concernedDepartments
            : item.concernedDepartments
                ? item.concernedDepartments?.split(',') // If comma-separated string
                : [];

        setConcernedDepartments(departmentArray.map((d) => ({ value: d, label: d })));
        setItemGroup({ label: `${item.itemGroupCode} - ${item.itemGroup}`, value: item.itemGroup })
        setType({ label: item.type, value: item.type })
        setUom({ label: `${item.unit} - ${item.uom}`, value: item.uom });
        setItemGroupCode(item.itemGroupCode);
        setUnit(item.unit);
        const additionalNamesArray = Array.isArray(item.additionalNames)
            ? item.additionalNames
            : item.additionalNames
                ? item.additionalNames?.split(',') // If comma-separated string
                : [""];
        setAdditionalNames(additionalNamesArray.map((name) => name));
        setMmsName(item?.mmsName)
        setMmsCode(item?.mmsCode)
        setMmsDesc(item?.mmsDesc)
        setHsn(item?.hsn)
        setSecondaryUom(
            item?.secondaryUom
                ? { label: `${item.secondaryUnit} - ${item.secondaryUom}`, value: item.secondaryUom }
                : null
        );
        setSecondaryUnit(item?.secondaryUnit);
        setPrimaryQuantity(item?.primaryQuantity)
        setSecondaryQuantity(item?.secondaryQuantity)
    };

    return (
        <div className="container mt-5">
            <div className="d-flex justify-content-between align-items-center mb-1">
                <h3>MMS Mapping</h3>
            </div>
            <div>
                <button onClick={toggleFormVisibility} className="btn btn-success mb-1">
                    Cancel
                </button>
                <div className="formcontainer">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-3">
                                <label>MMS Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="mmsName"
                                    value={mmsName}
                                    onChange={handleChange(setMmsName)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>MMS Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="mmsCode"
                                    value={mmsCode}
                                    onChange={handleChange(setMmsCode)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>MMS Description</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="mmsDesc"
                                    value={mmsDesc}
                                    onChange={handleChange(setMmsDesc)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>HSN</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="hsn"
                                    value={hsn}
                                    onChange={handleChange(setHsn)}
                                />
                            </div>
                            <div className="col-md-2">
                                <label>Primary Quantity</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="primaryQuantity"
                                    value={primaryQuantity}
                                    onChange={handleChange(setPrimaryQuantity)}
                                />
                            </div>

                            <div className="col-md-3">
                                <label>Primary UOM</label>
                                <Select
                                    options={uoms}
                                    name="uom"
                                    onChange={handleSelectChange}
                                    value={uom}
                                    isDisabled
                                />
                            </div>

                            {/* Centered = icon without affecting label alignment */}
                            <div className="col-md-2">
                                <div className="d-flex justify-content-center" style={{ marginTop: '32px' }}>
                                    <FontAwesomeIcon icon={faEquals} size="lg" />
                                </div>
                            </div>

                            <div className="col-md-2">
                                <label>Secondary Quantity</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="secondaryQuantity"
                                    value={secondaryQuantity}
                                    onChange={handleChange(setSecondaryQuantity)}
                                />
                            </div>

                            <div className="col-md-3">
                                <label>MMS UOM</label>
                                <Select
                                    options={uoms}
                                    name="secondaryUom"
                                    onChange={handleSelectChange}
                                    value={secondaryUom}
                                />
                            </div>

                            <div className="border m-2 border-success"></div>
                            <div className="col-md-6">
                                <label>Inventory Group</label>
                                <Select
                                    options={itemGroups}
                                    name="itemGroup"
                                    onChange={handleSelectChange}
                                    value={itemGroup}
                                    isDisabled
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Type</label>
                                <Select
                                    options={[
                                        { value: "Asset", label: "Asset / Capital Nature" },
                                        { value: "Consumables", label: "Useable / Consumables" },
                                        { value: "Fixtures & Fittings", label: "Fixtures & Fittings" },
                                    ]}
                                    name="type"
                                    onChange={handleSelectChange}
                                    value={type}
                                    isDisabled
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Print Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="printName"
                                    value={printName}
                                    disabled
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Inventory Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="itemName"
                                    value={itemName}
                                    disabled
                                    onChange={handleChange(setItemName)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Size</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="size"
                                    disabled
                                    value={size}
                                    onChange={handleChange(setSize)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Color</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="color"
                                    value={color}
                                    disabled
                                    onChange={handleChange(setColor)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Made of (Material)</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="make"
                                    value={make}
                                    disabled
                                    onChange={handleChange(setMake)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Grade</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="grade"
                                    value={grade}
                                    disabled
                                    onChange={handleChange(setGrade)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Brand Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="brandName"
                                    value={brandName}
                                    disabled
                                    onChange={(e) => setBrandName(e.target.value)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Avg Weight</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="avgWeight"
                                    value={avgWeight}
                                    disabled
                                    onChange={(e) => setAvgWeight(e.target.value)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>UOM</label>
                                <Select
                                    options={uoms}
                                    name="uom"
                                    onChange={handleSelectChange}
                                    value={uom}
                                    isDisabled
                                />
                            </div>
                            <div className="col-md-6">
                                <label>Store Issuer Deptt</label>
                                <Select
                                    isMulti
                                    options={getOptions()}
                                    name="concernedDepartments"
                                    isDisabled
                                    onChange={handleConcernedDeptSelectChange}
                                    value={concernedDepartments}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Inventory Description</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="itemDesc"
                                    disabled
                                    value={itemDesc}
                                    onChange={(e) => setItemDesc(e.target.value)}
                                />
                            </div>
                            <div className="col-md-3">
                                <label>Remarks</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="remarks"
                                    value={remarks}
                                    disabled
                                    onChange={(e) => setRemarks(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="mb-3">
                            <label>Additional Names</label>
                            <div className="d-flex flex-wrap">
                                {additionalNames.map((name, index) => (
                                    <div
                                        key={index}
                                        className="me-3 mb-2 d-flex align-items-center"
                                        style={{ flexShrink: 0 }}
                                    >
                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{ width: "210px" }}
                                            placeholder={`Name ${index + 1}`}
                                            value={name}
                                            onChange={(e) =>
                                                handleAdditionalNameChange(index, e.target.value)
                                            }
                                            disabled
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="d-flex gap-3">

                            <button type="submit" className="btn btn-success" onClick={handleSubmit}>
                                Submit
                            </button>
                            {role == 'itManager' ? <button type="button" className="btn" style={{ backgroundColor: "#f55f84", color: 'white', width: '150px' }} onClick={handleUnMap}>
                                Unmap
                            </button> : null}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default MMSMappingForm;
